/**
 * Create routes in a laravelish way from a name and parameters
 *
 * @export
 * @class route
 */
export default function(name, params) {
  var routes = {
    'account.bookings.show': '/account/bookings/{booking}',
    'adventures.index': '/adventures',
    'adventures.show': '/adventures/{country}/{adventure}',
    login: '/login',
    logout: '/logout',
    'countries.show': '/countries/{country}',
    'charities.show': '/charities/{charity}',
    'faq' : '/faqs',
    'json.adventures.index': '/json/adventures',
    'json.adventures.show': '/json/adventures/{adventure}',
    'json.adventure-types.index': '/json/adventure-types',
    'json.bookings.store': '/json/bookings',
    'json.charities.index': '/json/charities',
    'json.countries.index': '/json/countries',
    'json.countries.show': '/json/countries/{country}',
    'json.enquiry.store': '/json/enquiries',
    'json.team-members.index': '/json/team-members',
    'json.team-members.show': '/json/team-members/{team_member}',
    'json.user': '/json/user',
    'password.reset': '/password/reset',
    'posts.index-json': '/json/journal/',
    'posts.show': '/journal/{post}',
    'terms-and-conditions': '/terms-conditions',
    'json.bookings.index': '/json/bookings',
    'account.bookings.show': '/account/bookings/{booking}',
    'json.account.invoices.index': '/json/account/invoices',
    'json.account.settings.edit': '/json/account/settings',
    'json.account.settings.update': '/json/account/settings',
    'json.guests.update': '/json/guests/{guest}',
    'json.bookings.update-guests': '/json/bookings/{booking}/update-guests',
    'json.bookings.show': '/json/bookings/{booking}',
    'json.payments.show': '/json/payments',
    'json.newsletter.store': '/json/newsletter',
    'formsubmissions.store': '/newsletters',
  };

  var url = routes[name];

  if (params) {
    Object.entries(params).forEach(([param, val]) => {
      url = url.replace('{' + param + '}', val);
    }, this);
  }

  return url;
}
